import React from "react";
import "./Navbar.scss"
import logo from "../../image/logo-ic.png"
import Button from "../Button/Button";
const Navbar = () => {
    return (
        <div className="RewardsTickNavbar">
            <div className="RewardsTickNavbar-inner">
                <div className="RewardsTickNavbar-inner-left">
                    <img alt="" src={logo} />
                    RewardsTick
                </div>
                <div className="RewardsTickNavbar-inner-right">
                    <div className="RewardsTickNavbar-inner-right-nav-text">Features</div>
                    <div className="RewardsTickNavbar-inner-right-nav-text">How it Works</div>
                    <div className="RewardsTickNavbar-inner-right-nav-text">Benefits</div>
                    <Button isPrimary={false} buttonText={"Get Started"} />
                </div>
            </div>
        </div>
    )
}
export default Navbar